var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.siteTour'] = (function () {
    'use strict';

    const CONFIG = {
        COOKIE_NAME: "BHFCU_SiteTour",
        COOKIE_VALUE: "Closed",
        CLOSE_BTN_SELECTOR: "button[data-site-tour='close']"
    };

    const initialize = (widget) => {

        const carouselEl = widget.querySelector(".splide");
        const splide = carouselEl ? carousel(carouselEl) : null;

        const panel = widget.closest(".modal, .offcanvas");
        if (panel) {
            bindCloseButtons(widget, panel);
            bindPanelShown(widget, panel, splide);
        }

    }

    // The widget is initialized while the panel is still display:none, so Splide measures every slide as visible
    // and never sets tabindex="-1" on the off-screen slides' buttons. Once the panel is shown, refresh Splide so it
    // re-measures, then move focus to the first slide so screen readers start reading there instead of the top of the page.
    // As a carousel, focus the track rather than the slide itself - see focusTrackIfStranded
    const bindPanelShown = (widget, panel, splide) => {

        const shownEvent = panel.classList.contains("modal") ? "shown.bs.modal" : "shown.bs.offcanvas";

        panel.addEventListener(shownEvent, () => {
            const isCarousel = splide && !splide.state.is(Splide.STATES.DESTROYED);
            if (isCarousel) splide.refresh();

            const focusTarget = isCarousel
                ? widget.querySelector(".splide__track")
                : widget.querySelector(".slide .slide-content");
            if (focusTarget) {
                focusTarget.setAttribute("tabindex", "-1");
                focusTarget.focus();
            }
        });
    }

    // Every way out of the panel - the frame's close button and the widget's own - marks the tour closed
    const bindCloseButtons = (widget, panel) => {

        const setCookie = () => App.Cookies.setItem(CONFIG.COOKIE_NAME, CONFIG.COOKIE_VALUE, Infinity, "/", window.location.hostname, window.location.protocol === "https:");

        panel.querySelectorAll("button[data-bs-dismiss]").forEach(button => {
            button.addEventListener("click", setCookie);
        });

        widget.querySelectorAll(CONFIG.CLOSE_BTN_SELECTOR).forEach(button => {
            button.addEventListener("click", () => {
                setCookie();
                const panelInstance = panel.classList.contains("modal")
                    ? bootstrap.Modal.getInstance(panel)
                    : bootstrap.Offcanvas.getInstance(panel);
                if (panelInstance) panelInstance.hide();
            });
        });
    }

    const carousel = (carousel) => {

        const splideOptions = {
            pagination: false,
            gap: '50px',
            breakpoints: {
                991: {
                    destroy: true,
                },
            }
        };

        return App.Helpers.splideFallback(
            carousel,
            splideOptions,
            function (splide) {
                splideEventBindings(splide, carousel);
            }
        );
    }

    const splideEventBindings = (splide, carousel) => {

        const splideButtons = carousel.querySelectorAll("button[data-slide]");
        const current = carousel.querySelector(".splide__status-current");
        const count = carousel.querySelector(".splide__status-count");

        splide.on('mounted move', function () {
            current.textContent = splide.index + 1;
            count.textContent = splide.Components.Controller.getEnd() + 1;
        });

        splide.on('moved', function () {
            focusTrackIfStranded(splide, carousel);
        });

        splideButtons.forEach(button => {
            button.addEventListener("click", function () {
                handleSplideButton(button, splide);
            });
        });
    }

    // Browsers ignore aria-hidden on a slide that still contains focus (e.g. after "Start Tour" or "Start Over"), so a
    // slide moved out of view stays readable and the track's live region re-reads it along with the current slide.
    // Pull focus up to the track so the old slide can be hidden
    const focusTrackIfStranded = (splide, carousel) => {

        const focusedSlide = document.activeElement?.closest(".splide__slide");
        const activeSlide = splide.Components.Slides.getAt(splide.index)?.slide;
        if (!focusedSlide || focusedSlide === activeSlide) return;

        const track = carousel.querySelector(".splide__track");
        track.setAttribute("tabindex", "-1");
        track.focus();
    };

    const handleSplideButton = (button, splide) => {

        const whichSlide = parseInt(button.getAttribute("data-slide"));
        const isSplide = button.closest(".splide")?.classList.contains("splide--slide");

        if (isSplide) {
            splide.go(whichSlide);
        }
        else {
            const scroller = button.closest(".modal, .offcanvas-default__scroll");
            const target = scroller ? scroller : window;
            const slide = (scroller ? scroller : document).querySelector(`.slide:nth-child(${whichSlide + 1})`);
            const height = slide ? slide.offsetTop : 0;

            target.scrollTo({
                top: height,
                behavior: "smooth"
            });
        }

    };

    return {
        initialize
    };

})();